import HomeContainer from "../HomeContainer/HomeContainer";

import {

    SkeletonBox

} from "../../common/Skeleton";

import "./Categories.css";

export default function CategoriesSkeleton() {

    return (

        <HomeContainer>

            <section className="home-categories">

                <div

                    className="home-categories__skeleton"

                >

                    {

                        Array.from({

                            length: 6

                        }).map((_, index) => (

                            <SkeletonBox

                                key={index}

                                height={150}

                                radius={16}

                            />

                        ))

                    }

                </div>

            </section>

        </HomeContainer>

    );

}